<div class="gl-dashboard__dropdown" [ngClass]="{ activeDropdown: toggleDropdown }">
  <span (click)="toggleDropdown = !toggleDropdown">{{ selectedItem['name'] | translate }}</span>
  <span
    [ngClass]="toggleDropdown ? 'glicon-up-arrow' : 'glicon-down-arrow'"
    (click)="toggleDropdown = !toggleDropdown"
  ></span>
  <div class="gl-dashboard__dropdown--options">
    <span
      *ngFor="let item of selectionList; index as i; trackBy: trackByList"
      [ngClass]="{ active: selectedItem['key'] === item['key'] }"
      (click)="onClickItem(item)"
      >{{ item['name'] | translate }}</span
    >
  </div>
</div>
